import { BASE_API } from '../../utils/constantes'
import { getToken } from './token'

const BASE_CHATBOT = `${BASE_API}/api-chatbot`

const jsonHeaders = () => ({
    "Content-Type": "application/json",
    Authorization: `Bearer ${getToken()}`
})

/**
 * Manda el historial del chat al asistente y devuelve su respuesta.
 * El historial vive en el navegador: el backend solo registra la consulta para auditoria.
 *
 * @param {{mensajes: Array<{rol: 'usuario'|'asistente', contenido: string}>, contexto?: {ruta?: string}}} params
 * @returns {Promise<{respuesta: string, herramientas_usadas: Array, enlaces: Array, consulta_id: number, uso: object}>}
 */
export async function consultarChatbot({ mensajes, contexto = {} }) {
    const url = `${BASE_CHATBOT}/consulta/`
    const params = {
        method: "POST",
        headers: jsonHeaders(),
        body: JSON.stringify({ mensajes, contexto })
    }
    const response = await fetch(url, params)
    const data = await response.json().catch(() => ({}))

    if (response.status !== 200) {
        const mensaje = data.message || data.detail || `Error ${response.status} al consultar al asistente`
        const error = new Error(mensaje)
        error.status = response.status
        throw error
    }

    return data
}
